export default __webpack_public_path__ + "static/media/scritt-deally.ad19e0be.svg";